import { Controller } from "@hotwired/stimulus"

// Scroll back to the top of the page after a pagination click (any control --
// numbered pages, First/Previous/Next/Last, page-size) or typing a new search
// query, same as the top-of-results behavior elsewhere in the filters.
// Tag/platform filter clicks still deliberately leave scroll position alone
// even though they reload this same frame -- only pagination (including
// page-size) and search-query typing arm this.
//
// The filters form lives in the layout (content_for :catalog_chrome) while
// this controller is on the games_list turbo-frame inside <main> -- they're
// siblings, not ancestor/descendant, so a plain Stimulus data-action from
// the search input can't reach this controller directly. armScroll is
// dispatched as a document-level custom event instead (see
// SearchFormController#onQueryInput).
export default class extends Controller {
  connect() {
    this.armed = false
    this.onFrameLoad = this.scrollIfArmed.bind(this)
    this.boundArm = this.arm.bind(this)
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad)
    document.addEventListener("games-list:arm-scroll", this.boundArm)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad)
    document.removeEventListener("games-list:arm-scroll", this.boundArm)
  }

  arm() {
    this.armed = true
  }

  scrollIfArmed() {
    if (!this.armed) return

    this.armed = false
    window.scrollTo({ top: 0, behavior: "auto" })
  }
}
